import { ResPillStatus } from '../../components/res-pill/res-pill.component';
import { ResultStatus } from '../../models/test-run.model';
import { TEST_RUN_TO_RES_PILL } from '../../shared/test-run-outcome';

/**
 * Ergebnis-Status im Runner: als Pillen-Variante und als i18n-Schluessel.
 *
 * <p>Seite und Manuell-Runner zeigen denselben Status an zwei Stellen — die
 * Kopfzeile des Durchlaufs und jeden Schritt. Lag die Abbildung in beiden
 * Komponenten, koennten sie beim naechsten Statuswert auseinanderlaufen.
 */
export function runnerPillStatus(status: ResultStatus): ResPillStatus {
  return TEST_RUN_TO_RES_PILL[status];
}

export function runnerResultKey(status: ResultStatus): string {
  return 'testRunner.result.' + status;
}
